module.exports = __webpack_public_path__ + "static/media/Formular-Medium.419fa9c2.ttf";